package components

import it.neckar.lizergy.model.company.UserResolver
import it.neckar.react.common.addClass
import it.neckar.lizergy.model.company.user.UserInformation
import it.neckar.user.UserLoginName
import kotlinx.html.title
import react.RBuilder
import react.dom.*

private const val UnavailableUserTitle: String = "Nutzer ist nicht mehr verfügbar"

/**
 * Renders the name of the [user]. The name of a deleted user ([UserInformation.isEndOfLife]) is struck through and carries a tooltip.
 */
fun RBuilder.userName(user: UserInformation) {
  span {
    if (user.isEndOfLife()) {
      attrs {
        title = UnavailableUserTitle
      }
      addClass("text-decoration-line-through")
    }
    +user.editorName
  }
}

/**
 * Renders the name of the user for the [loginName] or "-" if there is no [loginName].
 */
fun RBuilder.userName(loginName: UserLoginName?, userResolver: UserResolver) {
  if (loginName == null) {
    +"-"
    return
  }

  userName(userResolver[loginName])
}

/**
 * The name of the user for a place that renders plain text only (e.g. a title attribute).
 * Marks the name of a deleted user.
 */
fun UserInformation.editorNameForText(): String {
  return if (isEndOfLife()) "$editorName ($UnavailableUserTitle)" else editorName
}
